export { getPrefersColorSchema } from '../../utils/getPrefersColorSchema';
